module.exports = __webpack_public_path__ + "static/media/bg28.856b09ec.jpg";